/* Behaviour for the landing-* sections.
   Two small enhancements, both progressive: without this file the stat bars
   render filled and every offer card stays expanded with its own add-to-cart. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Stat bars ------------------------------------------------------------ */
  function initStats(root) {
    var groups = root.querySelectorAll('[data-lp-stats]');
    if (!groups.length) return;

    var stats = [];
    groups.forEach(function (group) {
      group.querySelectorAll('.lp-stat').forEach(function (stat) {
        stats.push(stat);
      });
    });
    if (!stats.length) return;

    // No IntersectionObserver (or the user asked for less motion): show the
    // finished state straight away rather than leaving empty bars behind.
    if (reduceMotion || typeof IntersectionObserver === 'undefined') {
      stats.forEach(function (stat) {
        stat.classList.add('is-visible');
        var value = stat.querySelector('[data-lp-stat-number]');
        if (value) value.textContent = value.getAttribute('data-lp-stat-number');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          entry.target.classList.add('is-visible');
          countUp(entry.target.querySelector('[data-lp-stat-number]'));
        });
      },
      { threshold: 0.4 }
    );

    stats.forEach(function (stat) {
      observer.observe(stat);
    });
  }

  function countUp(el) {
    if (!el) return;
    var target = parseFloat(el.getAttribute('data-lp-stat-number'));
    if (isNaN(target)) return;

    var duration = 1200;
    var start = null;

    function frame(timestamp) {
      if (start === null) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      // Same easing as the bar fill, so the number and the bar land together.
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(target * eased).toString();
      if (progress < 1) window.requestAnimationFrame(frame);
    }

    window.requestAnimationFrame(frame);
  }

  /* Offer selector ------------------------------------------------------- */
  function initOffers(root) {
    root.querySelectorAll('[data-lp-offer]').forEach(function (offer) {
      var cards = offer.querySelectorAll('.lp-offer__card');
      if (cards.length < 2) return;

      offer.classList.add('lp-offer--js');

      function select(card) {
        cards.forEach(function (other) {
          var isSelected = other === card;
          other.classList.toggle('is-selected', isSelected);
          var radio = other.querySelector('.lp-offer__radio');
          if (radio) radio.checked = isSelected;
        });
      }

      cards.forEach(function (card) {
        var radio = card.querySelector('.lp-offer__radio');
        if (radio) {
          radio.addEventListener('change', function () {
            select(card);
          });
        }

        // The whole head is the hit area, but clicks on the radio itself are
        // left to the change handler above so the label stays keyboard-usable.
        var head = card.querySelector('.lp-offer__head');
        if (head) {
          head.addEventListener('click', function (event) {
            if (event.target === radio) return;
            select(card);
          });
        }
      });

      var checked = offer.querySelector('.lp-offer__radio:checked');
      select(checked ? checked.closest('.lp-offer__card') : cards[0]);
    });
  }

  function init(root) {
    initStats(root);
    initOffers(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Re-run for the section the merchant is editing in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
